export default "__VITE_ASSET__vp87BNEf__"